const indexItems = [
  { label: '动作冒险', count: 1528, icon: 'ri-sword-line' },
  { label: '科幻奇幻', count: 893, icon: 'ri-rocket-line' },
  { label: '喜剧搞笑', count: 2104, icon: 'ri-emotion-laugh-line' },
  { label: '爱情浪漫', count: 1672, icon: 'ri-heart-line' },
  { label: '悬疑推理', count: 945, icon: 'ri-search-eye-line' },
  { label: '恐怖惊悚', count: 667, icon: 'ri-ghost-line' },
  { label: '动画动漫', count: 1340, icon: 'ri-movie-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-500 tracking-widest uppercase mb-2">Categories</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            影视索引
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            按类型快速浏览，总有一部你会喜欢
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.label}
              className="group bg-background-50 rounded-xl p-6 text-center border border-background-200/60 cursor-pointer hover:border-accent-300/40 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1 whitespace-nowrap">{item.label}</h3>
              <p className="text-xs text-foreground-400">{item.count} 部</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}